// extracted by mini-css-extract-plugin
export var headerCell = "_5v-1";
export var loadingSpinnerContainer = "_5v-4";
export var loadingStateCell = "_5v-5";
export var rowWrapper = "_5v-3";
export var standaloneTable = "_5v-6";
export var table = "_5v-0";
export var white = "_5v-2";